/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = Active
 *
 * 2 = Removed
 */
export enum ModuleStatus {
  Active = 1,
  Removed = 2,
}
